import React, { useCallback, useContext, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import './AddPeople.css';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import clsx from 'clsx';
// import DateTimePicker from 'react-datetime-picker';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setMinutes, setHours } from 'date-fns';

function AddPeople() {
	const { firebase } = useContext(FirebaseContext);

	const [success, setSuccess] = useState('');
	const [loading, setLoading] = useState(false);

	const [formData, setFormData] = useState({
		clientEmailAddress: '',
		dateTime: '',
		clientName: '',
		clientPhone: '',
		guestEmailAddress1: '',
		guestEmailAddress2: '',
	});
	const [startDate, setStartDate] = useState(new Date());

	const {
		clientEmailAddress,
		dateTime,
		clientName,
		clientPhone,
		guestEmailAddress1,
		guestEmailAddress2,
	} = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const handleCreateEvent = useCallback(async (e) => {
		e.preventDefault();
		setLoading(true);
		setFormData({
			clientEmailAddress: '',
			dateTime: '',
			clientName: '',
			clientPhone: '',
			guestEmailAddress1: '',
			guestEmailAddress2: '',
		});

		//reference and push to /client_appointments/[project_code]
		try {
			// var appointmentPost = await firebase
			// 	.database()
			// 	.ref('/client_appointments/' + PROJECT_CODE.projectCode)
			// 	.push();
			var currentUserId = firebase.auth().currentUser.uid;

			var date = new Date(startDate);
			var timeInMillisec = date.getTime();

			//set the data to the database
			var appointmentPost = {
				appointmentID: 'none',
				appointmentName: 'Adhoc_Appointment_Made_by_Admin_',
				timeOfAppointment: timeInMillisec,
				assignedTo: 'Adhoc',
				started: false,
				createrID: currentUserId,
				sentRemind: false,
				createUser: true,
			};

			console.log(
				'Email: ' +
					clientEmailAddress +
					', full name: ' +
					clientName +
					', phone number: ' +
					clientPhone
			);

			var users = {
				'0': {
					email: clientEmailAddress,
					fullName: clientName,
					phoneNumber: clientPhone,
				},
			};

			if (guestEmailAddress1 !== 'undefined' && guestEmailAddress1 !== '') {
				users['1'] = {
					email: guestEmailAddress1,
					fullName: 'undefined',
					phoneNumber: 'undefined',
				};
			}

			if (guestEmailAddress2 !== 'undefined' && guestEmailAddress2 !== '') {
				users['2'] = {
					email: guestEmailAddress2,
					fullName: 'undefined',
					phoneNumber: 'undefined',
				};
			}

			appointmentPost['users'] = users;

			var createNewAppointment = await firebase
				.functions()
				.httpsCallable('CreateMeetingFromData');

			var shortCode;

			await createNewAppointment(appointmentPost)
				.then((result) => {
					console.log('results: ' + result.data.shortCode);
					shortCode = result.data.shortCode;
				})
				.catch(function (error) {
					console.log('Error ' + error);
				});

			var appointmentID = shortCode;

			console.log('Short code for this ' + appointmentID);
			var link =
				'https%3A%2F%2F' +
				PROJECT_CODE.projectCode +
				'.web.app%2Fsignup%3Flinkid%3D' +
				appointmentID +
				'_split_ADMIN';

			var timeAltered = timeInMillisec - 14400000;
			var dateObj = new Date(timeAltered);
			var theDay = dateObj.getDate();
			var theMonth = dateObj.getMonth();
			theMonth = theMonth + 1;
			var theYear = dateObj.getFullYear();
			var appStartTimeDate;

			appStartTimeDate = theYear.toString();

			if (theMonth < 10) {
				appStartTimeDate = appStartTimeDate + '0' + theMonth.toString();
				if (theDay < 10) {
					appStartTimeDate = appStartTimeDate + '0' + theDay.toString();
				} else {
					appStartTimeDate = appStartTimeDate + theDay.toString();
				}
			} else {
				appStartTimeDate = appStartTimeDate + theMonth.toString();
				if (theDay < 10) {
					appStartTimeDate = appStartTimeDate + '0' + theDay.toString();
				} else {
					appStartTimeDate = appStartTimeDate + theDay.toString();
				}
			}

			var hours = dateObj.getUTCHours();
			var minutes = dateObj.getMinutes();
			var appStartTimeHour;
			var appEndTimeHourFloat = hours;
			var appEndTimeString;

			console.log(' about to get day end');
			if (minutes >= 15) {
				appEndTimeHourFloat = hours + 1;
				var newMinTime = minutes + 45 - 60;

				if (hours < 10) {
					console.log('Hours less than 10 start');
					appEndTimeString = '0' + appEndTimeHourFloat.toString();

					if (newMinTime < 10) {
						appEndTimeString =
							appEndTimeString + '0' + newMinTime.toString() + '00';
					} else {
						appEndTimeString = appEndTimeString + newMinTime.toString() + '00';
					}
					console.log('Hours less than 10 end');
				} else {
					console.log('Hours greater than 10 start');
					appEndTimeString = appEndTimeHourFloat.toString();

					if (newMinTime < 10) {
						appEndTimeString =
							appEndTimeString + '0' + newMinTime.toString() + '00';
					} else {
						appEndTimeString = appEndTimeString + newMinTime.toString() + '00';
					}
					console.log('Hours greater than 10 end');
				}
			} else {
				var newMinutes = minutes + 45;
				if (hours < 10) {
					appEndTimeString = '0' + hours.toString();
					//var newMinutes = minutes + 45;

					appEndTimeString = appEndTimeString + newMinutes.toString() + '00';
				} else {
					//var newMinutes = minutes + 45;
					appEndTimeString = hours.toString();

					appEndTimeString = appEndTimeString + newMinutes.toString() + '00';
				}
			}
			console.log('time again');
			if (hours < 10) {
				appStartTimeHour = '0' + hours.toString();

				if (minutes < 10) {
					appStartTimeHour = appStartTimeHour + '0' + minutes.toString() + '00';
				} else {
					appStartTimeHour = appStartTimeHour + minutes.toString() + '00';
				}
			} else {
				appStartTimeHour = hours.toString();

				if (minutes < 10) {
					appStartTimeHour = appStartTimeHour + '0' + minutes.toString() + '00';
				} else {
					appStartTimeHour = appStartTimeHour + minutes.toString() + '00';
				}
			}

			var fNameReplace = clientName.replace(/ /g, '%20');
			var fEmailReplace = clientEmailAddress.replace('@', '%40');
			var fEmailReplace2 = fEmailReplace.replace('.', '%2E');
			var phoneReplace = clientPhone.replace(/-/g, '%2D');
			var additionalDescription = '%20';
			var appointmentName =
				'Adhoc_Appointment_Made_by_Admin_ ' +
				firebase.auth().currentUser.displayName;
			var str = appointmentName;
			var replacementUnder = str.replace(/_/g, '%20');
			console.log('REPLACED STRING1  ' + replacementUnder);
			var callenderLink =
				'https://www.google.com/calendar/render?action=TEMPLATE&text=' +
				replacementUnder +
				'&details=Name%3A%20' +
				fNameReplace +
				'%20Email%3A%20' +
				fEmailReplace2 +
				'%20Phonenumber%3A%20' +
				phoneReplace +
				'%20Join%20Meeting%3A%20' +
				link +
				'&dates=' +
				appStartTimeDate +
				'T' +
				appStartTimeHour +
				'%2F' +
				appStartTimeDate +
				'T' +
				appEndTimeString +
				'&ctz=America%2FNew_York';

			// if (
			// 	window.confirm('Do you want to add this event to your Google Calendar?')
			// ) {
			// 	AddToCalender(callenderLink);
			// } else {
			// 	console.log('Event not added to Google Calendar');
			// }

			setSuccess('Appointment set. Clients will receive the emails shortly');
			setLoading(false);
			setTimeout(() => setSuccess(''), 3000);
		} catch (error) {
			console.log(error);
		}
	});

	// const AddToCalender = (googleLink) => {
	// 	window.open(googleLink);
	// 	window.focus();
	// };

	const useStyles = makeStyles((theme) => ({
		datePicker: {
			outline: 'none',
			borderTop: 'none !important',
			borderLeft: 'none !important',
			borderRight: 'none !important',
			borderBottom: '1px solid #949494 !important',
			borderRadius: '0 !important',
			width: '100% !important',
		},
		appointmentField: {
			marginTop: '15px',
			color: '#777777',
		},
		textfield: {
			width: '100%',
		},
	}));

	const styles = useStyles();

	return (
		<div className='home-card'>
			{loading && (
				<div className='loading_layout_add_people'>
					<CircularProgress
						style={{ position: 'fixed', left: '50%', top: '50%' }}
					/>
				</div>
			)}
			<form
				action=''
				className='form formAddPeople'
				onSubmit={handleCreateEvent}
			>
				{success && <p className='form-success'>{success}</p>}
				<div className='card-header'>
					<h2>SCHEDULE A MEETING</h2>
					{/* <small>Schedule a meeting with your clients</small> */}
				</div>
				<div className='form-group'>
					<label
						className={clsx(
							styles.field,
							styles.label,
							styles.appointmentField
						)}
					>
						Appointment Date and Time
					</label>
					<DatePicker
						selected={startDate}
						onChange={(date) => setStartDate(date)}
						minDate={Date.now()}
						minTime={setMinutes(new Date(), 0)}
						maxTime={setHours(setMinutes(new Date(), 45), 23)}
						showTimeSelect
						timeFormat='HH:mm'
						timeIntervals={15}
						timeCaption='time'
						dateFormat='MMMM d, yyyy h:mm aa'
						className={clsx(styles.field, styles.datePicker)}
					/>
				</div>
				<div className='form-group'>
					<TextField
						type='email'
						label='Client Email Address'
						name='clientEmailAddress'
						value={clientEmailAddress}
						onChange={(e) => onChange(e)}
						className={styles.textfield}
						required
					/>
				</div>
				<div className='form-group'>
					<TextField
						type='text'
						label='Client Name'
						name='clientName'
						value={clientName}
						onChange={(e) => onChange(e)}
						className={styles.textfield}
						required
					/>
				</div>
				<div className='form-group'>
					<TextField
						type='tel'
						label='Client Phone Number (1231231234)'
						inputProps={{ pattern: '[0-9]{3}[0-9]{3}[0-9]{4}' }}
						name='clientPhone'
						value={clientPhone}
						onChange={(e) => onChange(e)}
						className={styles.textfield}
						required
					/>
				</div>
				<div className='form-group'>
					<TextField
						type='email'
						label='Guest Email'
						name='guestEmailAddress1'
						value={guestEmailAddress1}
						onChange={(e) => onChange(e)}
						className={styles.textfield}
					/>
				</div>
				<div className='form-group'>
					<TextField
						type='email'
						label='Guest Email'
						name='guestEmailAddress2'
						value={guestEmailAddress2}
						onChange={(e) => onChange(e)}
						className={styles.textfield}
					/>
				</div>

				<input
					type='submit'
					className='createEventBtn btn btn-primary'
					value='+ CREATE INVITE'
				/>
			</form>
		</div>
	);
}

export default AddPeople;
